define('components/ReportsMenu/ReportsMenuComponent',[
	'core/can',
	'template!components/ReportsMenu/ReportsMenuView.stache'
], function(can, template) {
	
	can.Component.extend({
	
		tag: 'reports-menu',
		
		template: can.view(template),
		
		events: {
			'inserted': 'handleSections',
			'{can.route} report': 'handleSections',

			'handleSections' : function(param) {
				var route = can.route.attr();

				if(route.page !== "dashboard") {
					var element = this.element;
					var id = route.page;

					if(id.toLowerCase() === 'reports') {
						id = route.report || 'Eft';
					}
					
					// param is of type object for can.route report event listener
					if(typeof param === 'object') {
						element.find('.collapse').removeClass('in').trigger('hide.bs.collapse');
					}

					switch(id.toLowerCase()) {
						case 'eft':
							element.find('#financialReports').addClass('in');
							break;
						case 'timelyfiling':
							element.find('#TimelyFilingReports').addClass('in');
							break;
						case 'cancellationrate':
						case 'claims':
						case 'claimcount':
						case 'tob':
						case 'stuckinsuspense':
						case 'reasoncode':
						case 'adr':
						case 'rtp':
						case 'rtpcanceled':
						case 'rejected':
						case 'suspense':
						case 'paid':
						case 'error':
							element.find('#claimReports').addClass('in');
							break;
						case 'patients':
						case 'eligibility':
						case 'eligibilityissues':
							element.find('#eligibilityReports').addClass('in');
							break;
					}
				}
			},
			
			'.collapse show.bs.collapse': function(el, ev) {
				el.parent('.menu-group').find('.fa').removeClass('fa-caret-right').addClass('fa-caret-down');
			},

			'.collapse hide.bs.collapse': function(el, ev) {
				el.parent('.menu-group').find('.fa').removeClass('fa-caret-down').addClass('fa-caret-right');
			}
		}
	});
});
